import * as React from 'react';

import { Box } from '@mui/material';

import Log from '@/Logger';
import { type User } from '@/auth';

import DocumentList from '../ui/document-list/DocumentList';
import Drawer from '../ui/drawer/Drawer';
import Error from '../ui/error/Error';
import Header from '../ui/header/Header';
import Footer from '../ui/footer/Footer';
import SendDocument from '../ui/sendDocument/SendDocument';
import RecycleBin from '../ui/recycle-bin/RecycleBin';
import Settings from '../ui/settings/Settings';

type Props = {
    user: User
    isAllowed: boolean
    status?: number
}

const Home = (props: Props) => {
    const logger = Log.getLogger();

    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const [isPdfEditVisible, setIsPdfEditVisible] = React.useState(false);
    const [isConflict, setIsConflict] = React.useState(false); // PDF編集画面で競合が発生しているかどうかのフラグ。ConfirmDialogの表示非表示の判断に使用する。

    const handleDrawerOpen = () => {
        logger.ui.info('Home', 'handleDrawerOpen');
        setDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        logger.ui.info('Home', 'handleDrawerClose');
        setDrawerOpen(false);
    };

    if (!props.user) {
        return (
            <>
                loading...
            </>
        )
    }


    if (props.isAllowed) {
        return (
            <>
                <Drawer
                    drawerOpen={drawerOpen}
                    handleDrawerClose={handleDrawerClose}
                    header={<Header user={props.user} handleDrawerOpen={handleDrawerOpen} drawerOpen={drawerOpen} iconButton={true} />}
                    documentList={<DocumentList user={props.user} isVisiblePdfEdit={isPdfEditVisible} setIsVisiblePdfEdit={setIsPdfEditVisible} isConflict={isConflict} setIsConflict={setIsConflict} />}
                    sendDocument={<SendDocument user={props.user} />}
                    config={<Settings user={props.user} />}
                    recycleBin={<RecycleBin user={props.user} />}
                    setIsPdfEditVisible={setIsPdfEditVisible}
                    isConflict={isConflict}
                    setIsConflict={setIsConflict}
                />
                <Footer />
            </>
        )
    } else {
        return (
            <>
                <Header drawerOpen={false} handleDrawerOpen={handleDrawerOpen} iconButton={false} />
                <Box style={{ paddingTop: '80px' }}>
                    <Error status={props.status} />
                </Box>
                <Footer />
            </>
        )
    }
};

export default Home;
